"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntitlementContextType = void 0;
const zod_1 = require("zod");
exports.EntitlementContextType = zod_1.z.enum(["user", "organization", "enterprise"]);
//# sourceMappingURL=context.js.map